import * as React from 'react';

import { ThumbUpIcon } from 'bundles/ai-course-coach/assets/mui';
import { CoachIconButton } from 'bundles/ai-course-coach/components/common';

import _t from 'i18n!nls/learning-assistant-chat-ai';

type Props = {
  selected?: boolean;
  onSelect(): void;
  onDeselect(): void;
};

const Like = ({ selected, onSelect, onDeselect }: Props) => {
  return (
    <div>
      {selected ? (
        <CoachIconButton
          size="small"
          aria-label={_t('Cancel like')}
          tooltip={_t('Cancel like')}
          onClick={onDeselect}
          icon={<ThumbUpIcon filled={true} />}
        />
      ) : (
        <CoachIconButton
          size="small"
          aria-label={_t('Like')}
          tooltip={_t('Like')}
          onClick={onSelect}
          icon={<ThumbUpIcon filled={false} />}
        />
      )}
    </div>
  );
};

export default Like;
